const removeSelectedFeatureFromSelectionLayer = (view) => {
  let selectionLayer = view.map.allLayers
    .filter((layer) => layer.id === "selectionLayer")
    .getItemAt(0);
  selectionLayer.remove(
    selectionLayer.graphics
      .filter(
        (graphic) =>
          graphic.attributes.OBJECTID ===
          view.popup.selectedFeature.attributes.OBJECTID
      )
      .getItemAt(0)

  );
  view.popup.features = view.popup.features.filter((feature) => {
    return !(
      feature.attributes.OBJECTID ===
      view.popup.selectedFeature.attributes.OBJECTID &&
      feature?.parentLayerId
    );
  });
  if (view.popup.features.length === 0) {
    view.popup.close();
  } else {
    view.popup.next();
  }
}
export default removeSelectedFeatureFromSelectionLayer